import React, { useEffect, useState } from 'react'
import PageHeader from '../../Components/PageHeader'
import { Link } from 'react-router-dom'
import showToast from '../../helpers/show_toast';
import { getSubmitForm } from '../../helpers/forms_helper';
import Loader from '../../Components/Loader';
import moment from 'moment';

const AllNews = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetch_data();
    }, []);
    const [allData, setAllData] = useState([]);
    const fetch_data = async () => {
        setLoading(true)
        // let url = process.env.VITE_APP_BASEURL + "news/getall";
        let url = "https://api.jmialumnivic.com.au/news/getall";
        const response = await getSubmitForm(url, '')
        if (response && response.status === 1) {
            setAllData(response.data);
            setLoading(false)
        } else {
            setLoading(false)
            showToast(response.error, "error")
        }
    };
    return (
        <>
            <section className='history_of_osa'>
                <div className="about_osa_layer">
                    <PageHeader heading="News & Events" />
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="about_main_container">
                                    <div className="row">
                                        {loading ?
                                            <Loader />
                                            : allData && allData.length > 0 ?
                                                allData.map((data, idx) => {

                                                    return (
                                                        <>
                                                            <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={idx}>
                                                                <div className="card news_cards ">
                                                                    <img className="card-img-top" src={data?.image_urls ? data.image_urls[0] : ''} alt="Card image cap" />
                                                                    <div className="card-body">
                                                                        <h6 className="card-title"><b>{data.title}</b></h6>
                                                                        <p className="">{data.short_des}</p>
                                                                        {/* <div className='d-flex justify-content-between'>
                                                                            <Link to={`/news_detail/${btoa(data._id)}`} className="text-primary ">Read More <i className="fa-solid fa-chevron-right"></i></Link>
                                                                            <small>{moment(data.news_date).fromNow()}</small>
                                                                        </div> */}
                                                                    </div>
                                                                    <div className='card-footer bg_lightcolor pb-4'>
                                                                        <div className='d-flex justify-content-between'>
                                                                            <Link to={`/news_detail/${btoa(data._id)}`} className="text-primary fw-bold">Read More <i className="fa-solid fa-chevron-right fs-5"></i></Link>
                                                                            <small className='text-muted' style={{ fontWeight: '500' }}>{moment(data.news_date).format('Do MMM YY')}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                                : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AllNews
